import { Injectable } from 'angular-ts-decorators';
import { Domain } from './domain';

/**
 * Service that handles loyality functionality
 */
@Injectable('loyalty')
export class Loyalty {
  constructor(
    private $http: ng.IHttpService,
    private domain: Domain,
  ) {
    'ngInject';
  }

  /**
   * Creates Piggy portal session
   * @param payload
   * payload containts data.email
   * @return
   * Resolve with http response promise on successfu1lly returns piggy session url, reject otherwise.
   */
  createPiggyPortalSession(email: string): ng.IHttpPromise<any> {
    return this.$http
      .post(
        `${this.domain.getSpynl()}/pos/create-piggy-portal-session`,
        {
          data: { email },
        },
        {
          headers: { 'Content-Type': 'text/xml; charset=utf-8' },
          withCredentials: true,
        },
      )
      .then((response: any) => response.data.data.url);
  }
}
